import { CatchBoundary, Outlet } from '@tanstack/react-router';
import styled from 'styled-components';
import { useAppConfiguration } from '@mews-commander/data-access';
import { ErrorHandler, OverlayedLoader } from '@mews-commander/ui';
import { useCommanderSelector } from '@mews-commander/utils';
import { PlatformEnvironment } from '@mews/enums';
import { AlertsProvider, LocalizedText, useShortcuts } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Z_INDEX_ALERTS } from '../constants';
import { SnackbarHolder } from '../modules/alerts';
import { FakeModalManager } from '../modules/app/components/FakeModalManager';
import { isAppFetching } from '../modules/app/reducers/status';
import { AppNavbar } from '../modules/appNavbar';
import { AppSidebar } from '../modules/appSidebar';
import { AdditionalAuthorizationModal } from '../modules/auth/screens/AdditionalAuthorization/AdditionalAuthorizationModal';
import DialogsHolder from '../modules/dialog/components/DialogsHolder';
import { HelpCenterSidebar } from '../modules/helpCenter';
import IdentityDocumentScannerDialogsHolder from '../modules/identityDocumentScanner/containers/IdentityDocumentScannerDialogsHolder';
import { Shortcuts } from '../modules/shortcuts';

/**
 * Layout to use with Tanstack Router for authenticated routes
 */
export const AuthenticatedLayout = () => {
    useShortcuts(Shortcuts);
    const isFetching = useCommanderSelector(isAppFetching);
    const { environment } = useAppConfiguration();
    const showStackTrace = environment !== PlatformEnvironment.Production && environment !== PlatformEnvironment.Demo;

    return (
        <AlertsProvider zIndex={Z_INDEX_ALERTS}>
            <PrivateContentWrapper>
                {/* @ts-expect-error $TSFixMeError */}
                <AppNavbar />
                <ContentElement>
                    <FakeModalManager>
                        <CatchBoundary
                            getResetKey={() => 'resetAuthenticatedRoute'}
                            errorComponent={({ error, reset }) => (
                                <ErrorHandler
                                    stackTrace={showStackTrace ? error.stack : undefined}
                                    errorMessage={<LocalizedText textKey={TextKey.GenericErrorMessage} />}
                                    errorTitle={<LocalizedText textKey={TextKey.GenericErrorTitle} />}
                                    onDismiss={reset}
                                />
                            )}
                        >
                            <Outlet />
                        </CatchBoundary>
                    </FakeModalManager>
                    {/* @ts-expect-error $TSFixMeError */}
                    <AppSidebar />
                </ContentElement>
            </PrivateContentWrapper>
            <DialogsHolder />
            <OverlayedLoader show={isFetching} />
            <SnackbarHolder />
            <IdentityDocumentScannerDialogsHolder />
            <HelpCenterSidebar />
            <AdditionalAuthorizationModal />
        </AlertsProvider>
    );
};

const PrivateContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-height: 100svh; /* stylelint-disable-line unit-no-unknown */
    box-sizing: border-box;
`;

const ContentElement = styled.div`
    position: relative;
    flex: 1 1;
    display: flex;
`;
